var voted_users_rtlignore_default = {
  "container": "DKZMs",
  "webview": "mH8g-",
  "avatar_list": "z3n2-",
  "avatar": "zkaPJ",
  "user_avatar": "E9San",
  "modal": "oBMGq",
  "voted_users_modal": "_9KWvV",
  "overlay": "cun3p",
  "user_card": "RhmK6",
  "user_name": "_4rWNY",
  "voted_users_modal_header": "koyPb",
  "cta": "lAiAk",
  "close_icon": "HVg1q",
  "title": "h1dnG",
  "member_list_container": "VX-YQ",
  "member_list": "pcxc7",
  "loader": "ZGgzj",
  "anonymous_counter": "_3UuKm",
  "spinner": "uQCpc",
  "spin": "jt6sS"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
